import { el, setChildren } from 'redom';

import application from 'application';
import serverInterface from 'server-interface';

export async function createGrid(...parameters) {

  const { createGrid: createGridWrapper } = await import('ag-grid-wrapper');

  return createGridWrapper(...parameters);

}

class Directory {

  constructor(configuration) {

    this.pageId = configuration.pageId;
    this.nodeId = configuration.nodeId;
    this.collectionId = configuration.collectionId;
    this.collectionViewId = configuration.collectionViewId;
    this.initialized = configuration.initialized;
    this.onInitialize = configuration.onInitialize;

    this.records = [];
    this.view = null;

    this.el = el('.directory-main.ag-theme-quartz', [
      el('ht-spinner', {
        size: 'small'
      })
    ]);

  }

  async loadData() {

    return serverInterface.startup.dataCollectionViews.getDataCollectionViewForEditor(this.collectionViewId);

  }

  async initializeAndLoadData() {

    const filtersManager = application.dataManagers.get('DataCollectionFiltersManager');

    const result = await serverInterface.startup.dataCollectionViews.setupDataCollectionView({
      collectionId: this.collectionId,
      pageId: this.pageId
    });

    await filtersManager.loadAllForce(this.collectionId);

    this.onInitialize({
      collectionViewId: result.view._id,
      initialized: true
    });

    filtersManager.pushFilterReference(this.collectionId, result.view.filterId, {
      type: 'PAGE',
      _id: `${this.pageId}:${this.nodeId}`
    });

    return result;

  }

  async getData() {

    if (this.initialized === false) {
      return this.initializeAndLoadData();
    } else {
      return this.loadData();
    }

  }

  async initialize() {

    const [result] = await Promise.all([
      this.getData(),
      import('https://cdn.jsdelivr.net/npm/ag-grid-community/dist/ag-grid-community.min.js')
    ]);

    this.view = result.view;
    this.records = result.records.map(function mapper(record) {
      return record.data;
    });;

    setChildren(this.el, []);

    this.gridApi = await this.initializeGrid();

  }

  onmount() {

    this.initialize();

  }

  async initializeGrid() {

    const { createGrid: createGridWrapper } = await import('ag-grid-wrapper');

    const pageSize = this.view.pageSize;
    const gridOptions = {
      domLayout: 'autoHeight'
    };

    if (pageSize > 0) {
      gridOptions.pagination = true;
      gridOptions.paginationPageSize = pageSize;
      gridOptions.filter = false;
    }

    return createGridWrapper(this.el, {
      columns: this.view.columns,
      rowData: this.records,
      serverInterfaces: this.dataCollectionViewInterfaces,
      collectionViewId: this.collectionViewId
    }, gridOptions, {
      disableFilter: true
    });

  }

  update(configuration) {

    this.pageId = configuration.pageId;
    this.nodeId = configuration.nodeId;
    this.collectionId = configuration.collectionId;
    this.collectionViewId = configuration.collectionViewId;
    this.initialized = configuration.initialized;

    if (this.view !== null) {
      this.initialize();
    }

  }

}

export default Directory;